import React from "react";
import { Link } from "react-router-dom";
import StaticPageLayout from "./StaticPageLayout";

export default function About() {
  return (
    <StaticPageLayout titleIt="Chi siamo" titleEn="About">
      {(isIt) => (
        <>
          {isIt ? (
            <>
              <p>
                <strong>Arcane Chronicles</strong> è un gioco di ruolo narrativo
                a capitoli dove la trama prende vita grazie all'intelligenza
                artificiale, che reagisce dinamicamente alle tue scelte e disegna
                ogni scena in stile anime.
              </p>
              <p>
                Ispirato al sottogenere <em>isekai</em> giapponese, ti trasporta
                dalla Terra moderna in un mondo di fantasia dove combatti con un
                sistema di carte in stile TCG, raccogli una collezione unica,
                scambi con altri giocatori e affronti boss al termine di ogni
                capitolo.
              </p>

              <h2 className="font-heading text-xl text-[#cfb53b] mt-6">
                Tecnologia
              </h2>
              <ul className="list-disc pl-5">
                <li>Narrativa e dialoghi: Google Gemini 2.5 Flash</li>
                <li>Artwork: generazione immagini anime-style</li>
                <li>Frontend: React + Tailwind + shadcn/ui + react-pageflip</li>
                <li>Backend: FastAPI + MongoDB</li>
                <li>Pagamenti: Stripe (pacchetti Oro virtuali)</li>
              </ul>

              <h2 className="font-heading text-xl text-[#cfb53b]">Filosofia</h2>
              <p>
                Crediamo che ogni partita debba essere unica, personale e
                rigiocabile all'infinito. Niente trame preconfezionate: solo tu,
                il Sistema, le tue scelte e il libro che si scrive pagina dopo
                pagina.
              </p>

              <h2 className="font-heading text-xl text-[#cfb53b]">Documenti</h2>
              <p>
                <Link to="/terms" className="text-[#cfb53b] hover:underline">
                  Termini di Servizio
                </Link>
                {" · "}
                <Link to="/privacy" className="text-[#cfb53b] hover:underline">
                  Privacy
                </Link>
                {" · "}
                <Link to="/cookies" className="text-[#cfb53b] hover:underline">
                  Cookie Policy
                </Link>
                {" · "}
                <Link to="/contact" className="text-[#cfb53b] hover:underline">
                  Contatti
                </Link>
              </p>
            </>
          ) : (
            <>
              <p>
                <strong>Arcane Chronicles</strong> is a chapter-based narrative
                RPG where the storyline comes alive through AI, reacting
                dynamically to your choices and drawing each scene in anime
                style.
              </p>
              <p>
                Inspired by Japanese <em>isekai</em>, it transports you from
                modern Earth into a fantasy world where you battle with a TCG-style
                card system, collect a unique deck, trade with other players
                and face boss encounters at the end of each chapter.
              </p>

              <h2 className="font-heading text-xl text-[#cfb53b] mt-6">
                Technology
              </h2>
              <ul className="list-disc pl-5">
                <li>Narrative and dialogues: Google Gemini 2.5 Flash</li>
                <li>Artwork: anime-style image generation</li>
                <li>Frontend: React + Tailwind + shadcn/ui + react-pageflip</li>
                <li>Backend: FastAPI + MongoDB</li>
                <li>Payments: Stripe (virtual Gold packs)</li>
              </ul>

              <h2 className="font-heading text-xl text-[#cfb53b]">Philosophy</h2>
              <p>
                We believe every playthrough should be unique, personal and
                infinitely replayable. No pre-packaged storylines: only you,
                the System, your choices and the book that writes itself page
                by page.
              </p>

              <h2 className="font-heading text-xl text-[#cfb53b]">Documents</h2>
              <p>
                <Link to="/terms" className="text-[#cfb53b] hover:underline">
                  Terms of Service
                </Link>
                {" · "}
                <Link to="/privacy" className="text-[#cfb53b] hover:underline">
                  Privacy
                </Link>
                {" · "}
                <Link to="/cookies" className="text-[#cfb53b] hover:underline">
                  Cookie Policy
                </Link>
                {" · "}
                <Link to="/contact" className="text-[#cfb53b] hover:underline">
                  Contact
                </Link>
              </p>
            </>
          )}
        </>
      )}
    </StaticPageLayout>
  );
}
